import { EnvironmentDetail } from '@utils/EnvironmentDetailUtils';
import { RegionMappingService } from '@services/RegionMappingService';

import _ from 'lodash';

export class CoralEndpointProviderHelper {
    private static PDX_REGION = 'pdx';
    private static SIN_REGION = 'sin';
    public static getEndpoint(client) {
        if (client.hasOwnProperty('config')) {
            const domain = EnvironmentDetail.getDomain();
            let region = EnvironmentDetail.getRegion();
            let realm = EnvironmentDetail.getRealm();

            /**
             * Here we are overriding the region to pdx in case it's actually set as sin in the
             * region query parameter of the URL. This is because not all clients have sin endpoints
             * and till the time they expand to sin region we will have to use pdx endpoint. This will be
             * true for all the service clients for now.
             * TODO : Once all the services have expanded to sin region remove the below if statement
             * TODO : Add UTs for the below if statement once this logic has been tested
             */
            if (region && region.toLowerCase() === this.SIN_REGION) {
                region = this.PDX_REGION;
                realm = RegionMappingService.getAwsRegionFromAirportCode(region);
            }
            if (!_.isString(realm) || _.isEmpty(realm)) {
                try {
                    realm = RegionMappingService.getAwsRegionFromAirportCode(region);
                } catch (error) {
                    console.error(`Invalid or missing region := ${region}`);
                }
            }
            if (realm) {
                client.config.overrideRealm(realm);
            }
            client.config.overrideDomain(domain);
        }
        return client.config.endpoint();
    }
}
